import Cookies from 'js-cookie'

/**
 * CSRF-токен из cookie `csrftoken`.
 *
 * Django кладёт его на клиенте; если cookie недоступны — пустая строка.
 */
export default function getCSRFToken(): string {
  if (!process.env.IS_CLIENT) {
    return ''
  }

  try {
    return Cookies.get('csrftoken') || ''
  } catch {
    return ''
  }
}
